import { transformUser } from '../user/user.reducer';
import { mergeEntity, ObjectReducer } from '../store';
import { OnlineOfflineStatus } from './online-offline.model';

export const onlineOfflineReducer: ObjectReducer<'onlineOffline'> = (
  state = {},
  action,
) => {
  switch (action.type) {
    case 'WS_MESSAGE':
      if (action.payload.type === 'onlineOffline') {
        const data = action.payload.data;
        return Object.entries(data).reduce(
          (s, [userId, status]) =>
            mergeEntity<'onlineOffline'>(s, { status }, [
              'onlineOffline',
              userId,
            ]),
          state,
        );
      }

      return state;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/online-offline/online-offline.reducer.ts